import { Avatar, Box, Button, TextField, Typography } from "@mui/material";
import {
  ENTERPRISE_IMAGE_PATH,
  TEXT_COLOR,
  THEME,
  isEnterprise,
} from "../../theme";
import logo from "../../components/ResponsiveNavbar/logo.png";
import { personalInformationStageStyles } from "./styles";
import { PersonalInformationStageProps } from "./types";
import { styles } from "../../pages/InitialSettings/styles";
import { CustomCircularProgress } from "../ProgressComponents/CustomCircularProgress";

export const PersonalInformationStage: React.FC<
  PersonalInformationStageProps
> = ({
  setStage,
  bio,
  setBio,
  handleChangeProfilePic,
  profilePicUrl,
  checkValidation,
  isLoading,
}) => {
  return (
    <>
      <Box sx={personalInformationStageStyles.mainContainer}>
        <Box sx={personalInformationStageStyles.childOfMainComponent}>
          <Box
            sx={{
              ...styles.groupAddOutlinedIconContainer,
              color: TEXT_COLOR,
              borderColor: TEXT_COLOR,
            }}
          >
            <img
              src="/assets/icons/InitialSettingsIcons/passcode.svg"
              style={{
                ...styles.groupAddOutlinedIcon,
                filter: THEME === "dark" ? "invert(0%)" : "invert(100%)",
              }}
              alt=""
            />
          </Box>
          <img
            style={personalInformationStageStyles.logoImage}
            className="logo-image"
            src={isEnterprise ? ENTERPRISE_IMAGE_PATH : logo}
            alt="logo"
          />
          <Box sx={personalInformationStageStyles.textFieldContainer}>
            <Typography sx={{ fontSize: "18px" }}>Bio</Typography>
            <TextField
              value={bio}
              placeholder="Add bio"
              fullWidth
              sx={personalInformationStageStyles.textField}
              onChange={(e) => {
                setBio(e.target.value);
              }}
            />
          </Box>
          <Box sx={personalInformationStageStyles.textFieldContainer}>
            <Typography sx={{ fontSize: "18px" }}>Upload Photo</Typography>
            {profilePicUrl && (
              <Box sx={personalInformationStageStyles.profilePicContainer}>
                <Avatar
                  alt="profile"
                  sx={personalInformationStageStyles.avatar}
                  src={profilePicUrl}
                />
              </Box>
            )}
            <Box sx={personalInformationStageStyles.imageUploadInputContainer}>
              <input
                type="file"
                accept="image/svg+xml, image/png, image/jpeg, image/gif"
                style={personalInformationStageStyles.imageUploadInput}
                onChange={(e) => handleChangeProfilePic(e)}
              />
              <Box
                sx={{
                  ...styles.groupAddOutlinedIconContainer,
                  color: TEXT_COLOR,
                  borderColor: TEXT_COLOR,
                }}
              >
                <img
                  src="/assets/icons/InitialSettingsIcons/upload-cloud-02.svg"
                  style={styles.groupAddOutlinedIcon}
                  alt="icon"
                />
              </Box>
              <Typography>Click to upload or drag and drop</Typography>
              <Typography>SVG, PNG, JPG or GIF (max 800x400px)</Typography>
            </Box>
          </Box>
          <Box sx={personalInformationStageStyles.buttonsContainer}>
            <Button
              onClick={async () => {
                const isFirstStep = false;
                const isValid = await checkValidation(isFirstStep);
                if (isValid) setStage((prev) => prev + 1);
              }}
              sx={personalInformationStageStyles.button}
              fullWidth
            >
              {isLoading ? (
                <CustomCircularProgress size={22} customcolor="white" />
              ) : (
                "Next"
              )}
            </Button>
          </Box>
          <Box sx={personalInformationStageStyles.buttonsContainer}>
            <Button
              onClick={async () => {
                const isFirstStep = false;
                const isValid = await checkValidation(isFirstStep);
                if (isValid) setStage((prev) => prev + 1);
              }}
              sx={personalInformationStageStyles.skipButton}
              fullWidth
            >
              Skip
            </Button>
          </Box>
          <Box sx={personalInformationStageStyles.indicatorContainer}>
            <Box
              onClick={() => setStage(0)}
              sx={personalInformationStageStyles.indicatorDot}
            ></Box>
            <Box
              onClick={() => setStage(1)}
              sx={{
                ...personalInformationStageStyles.indicatorDot,
                backgroundColor: TEXT_COLOR,
              }}
            ></Box>
            <Box
              onClick={() => setStage(2)}
              sx={personalInformationStageStyles.indicatorDot}
            ></Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
